// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminPlugin = (client) => ({
    /**
     * `GET /admin/plugin`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPluginList
     * @source packages/medusa-plugin-searates-v2/src/api/admin/plugin/route.ts
     */
    ping: (query, headers) => client.fetch("/admin/plugin", { method: "GET", query, headers }),
});
//# sourceMappingURL=plugin.js.map